<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<h1 class="calibre26" id="calibre_pb_6"> <img alt="" class="calibre27" src="images/00003.jpeg"/> </h1>
<p class="calibre25"> <img alt="" class="calibre28" src="images/00004.jpeg"/> </p>
<span class="calibre16" id="calibre_pb_7"></span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_003.vue?46770f81